import { render, staticRenderFns } from "./accountInfo.vue?vue&type=template&id=5e4ef9f2&scoped=true"
import script from "./accountInfo.vue?vue&type=script&lang=js"
export * from "./accountInfo.vue?vue&type=script&lang=js"
import style0 from "./accountInfo.vue?vue&type=style&index=0&id=5e4ef9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4ef9f2",
  null
  
)

export default component.exports